import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';

const BannerEdit = () => {
  const { id } = useParams(); 
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    banner_heading: '',
    banner_image: null,
  });
  const [previewImage, setPreviewImage] = useState(null);
  const [loading, setLoading] = useState(true);

  // Fetch banner by ID
  useEffect(() => {
    const fetchBanner = async () => {
      try {
        const response = await axios.post(
          'https://cyberathon.com/multivendor/index.php/Api/Master_controller/get_banner_by_id',
          { banner_id: id },
          { headers: { 'Content-Type': 'application/json' } }
        );

        if (response.data.status && response.data.data) {
          const banner = response.data.data;
          setFormData({
            banner_heading: banner.banner_heading,
            banner_image: null, // file input empty initially
          });
          setPreviewImage(banner.banner_image_url);
        } else {
          toast.error('Failed to fetch banner data.');
        }
      } catch (error) {
        console.error('Error fetching banner:', error);
        toast.error('Something went wrong while fetching banner.');
      } finally {
        setLoading(false);
      }
    };

    fetchBanner();
  }, [id]);

  const handleInputChange = (e) => {
    setFormData((prev) => ({ ...prev, banner_heading: e.target.value }));
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFormData((prev) => ({ ...prev, banner_image: file }));
      setPreviewImage(URL.createObjectURL(file));
    }
  };

  const handleSubmit = async (e) => {
  e.preventDefault();

  if (!formData.banner_heading) {
    toast.warn('Banner heading is required.');
    return;
  }

  const data = new FormData();
  data.append('banner_id', id);
  data.append('banner_heading', formData.banner_heading);

  // only append if it's a File
  if (formData.banner_image instanceof File) {
    data.append('banner_image', formData.banner_image);
  }

  // Debug
  for (let pair of data.entries()) {
    console.log(pair[0], pair[1]);
  }

  try {
    const response = await axios.post(
      'https://cyberathon.com/multivendor/index.php/Api/Master_controller/update_banner',
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );

    if (response.data.status) {
      toast.success(response.data.message || 'Banner updated successfully!');
      navigate('/Banner');
    } else {
      toast.error(response.data.message || 'Failed to update banner.');
    }
  } catch (error) {
    console.error('Update error:', error);
    toast.error('Something went wrong while updating the banner.');
  }
};


  if (loading) return <p>Loading banner data...</p>;

  return (
    <div className="page-content">
      <div className="container-fluid">
        {/* Page Title */}
        <div className="row">
          <div className="col-12">
            <div className="page-title-box">
              <h4 className="mb-0 fw-semibold">Banner Edit</h4>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <a href="javascript:void(0);">Banner</a>
                </li>
                <li className="breadcrumb-item active">Edit Banner</li>
              </ol>
            </div>
          </div>
        </div>

        {/* Form Section */}
        <div className="row">
          <div className="col-lg-12">
            <form onSubmit={handleSubmit}>
              <div className="card">
                <div className="card-header">
                  <h4 className="card-title">Edit Banner</h4>
                </div>

                <div className="card-body row">
                  {/* Heading */}
                  <div className="col-lg-6">
                    <div className="mb-3">
                      <label className="form-label text-dark">Banner Heading</label>
                      <input
                        type="text"
                        name="banner_heading"
                        className="form-control"
                        placeholder="e.g., Summer Sale"
                        value={formData.banner_heading}
                        onChange={handleInputChange}
                        required
                      />
                    </div>
                  </div>

                  {/* Image */}
                  <div className="col-lg-6">
                    <div className="mb-3">
                      <label className="form-label text-dark">Banner Image</label>
                      <input
                        type="file"
                        accept="image/*"
                        className="form-control"
                        onChange={handleImageChange}
                      />
                      {previewImage && (
                        <div className="mt-2">
                          <img src={previewImage} alt="Preview" height={80} />
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                {/* Submit Button */}
                <div className="card-footer border-top">
                  <button type="submit" className="btn btn-primary">
                    Update Banner
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="footer">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 text-center">
              © Venton. Crafted by{' '}
              <iconify-icon
                icon="iconamoon:heart-duotone"
                className="fs-18 align-middle text-danger"
              />{' '}
              <a href="#" className="fw-bold footer-text" target="_blank" rel="noreferrer">
                Techzaa
              </a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default BannerEdit;
